import { MidfielderPlayer } from "./MidfielderPlayer";
import { Player } from "./Player";
import { Ball } from "../Ball";
import { MatchManager } from "../../MatchManager";

export class PlayersManager {

    public static currentInstance: PlayersManager;

    public hasMovingPlayers: boolean;

    public passingPlayer: MidfielderPlayer;
    public receivingPlayer: Player;

    private activePlayerIndex: number;
    private switchingPlayersArray: Player[];

    private changeReceivingPlayerTimerEvent: Phaser.TimerEvent;
    private game: Phaser.Game;
    private playersArray: Player[];
    private movingPlayersArray: Player[];
    private movementReferencePlayer: Player;
    private randomDataGenerator: Phaser.RandomDataGenerator;
    private playersNumber: number;
    private blinkingFactor: number;

    constructor(game: Phaser.Game) {

        PlayersManager.currentInstance = this;

        this.game = game;
        this.hasMovingPlayers = false;
        this.playersArray = [];
        this.switchingPlayersArray = [];
        this.movingPlayersArray = [];
        this.movementReferencePlayer = null;

        this.randomDataGenerator = new Phaser.RandomDataGenerator([1, 2, 3, 4]);
    }

    public init(): void {

        this.playersNumber = this.playersArray.length;

        if (this.playersNumber > 4) {
            this.blinkingFactor = .95;
        } else if (this.playersNumber > 2) {
            this.blinkingFactor = .98;
        } else {
            this.blinkingFactor = .99;
        }
    }

    public update(): void {

        if (!this.hasMovingPlayers) {
            return;
        }

        if (this.movementReferencePlayer.hasReachedLimit()) {

            let i: number = this.movingPlayersArray.length;

            while (i--) {
                this.movingPlayersArray[i].reverse();
            }
        }
    }

    public addPlayer(player: Player): void {

        this.playersArray.push(player);

        if (player.movementType !== Player.STILL) {

            if (this.movementReferencePlayer == null) {
                this.movementReferencePlayer = player;
            }

            this.movingPlayersArray.push(player);
            this.hasMovingPlayers = true;
        }
    }

    public onBallAttachedToForward(forward: any, ball: Ball): void {

        this.receivingPlayer = forward;

        // ponerlo por encima de to-do
        forward.bringToTop();

        forward.ball = ball;

        ball.parent.removeChild(ball);
        ball.x = forward.shootBall_px;
        ball.y = forward.shootBall_py;
        forward.addChild(ball);

        forward.prepareToShoot();
    }

    public onBallAttachedToMidfielder(midfielder: any, ball: Ball): void {

        this.passingPlayer = midfielder;

        // ponerlo por encima de to-do en el PegsContainer
        midfielder.bringToTop();

        midfielder.prepareToPass(ball);

        this.activePlayerIndex = 0;
        this.switchingPlayersArray.length = 0;

        for (let i = 0; i < this.playersArray.length; i++) {
            if (!this.playersArray[i].hasReceived) {
                this.switchingPlayersArray.push(this.playersArray[i]);
            }
        }

        // hacer un shuffle en el array switchingPlayersArray
        Phaser.ArrayUtils.shuffle(this.switchingPlayersArray);

        // poner en marcha un timer que ilumine los centrocampistas
        this.changeReceivingPlayerTimerEvent = this.game.time.events.loop(275, this.switchReceivingPlayer, this);

        this.switchReceivingPlayer();
    }

    public switchReceivingPlayer(): void {

        this.switchingPlayersArray[this.activePlayerIndex].turnOff();
        this.activePlayerIndex = this.activePlayerIndex < this.switchingPlayersArray.length - 1 ? this.activePlayerIndex + 1 : 0;
        this.switchingPlayersArray[this.activePlayerIndex].turnOn();
    }

    public passBall(): void {

        // cortar el tween del jugador que pasa
        this.passingPlayer.onPassBall();

        if (this.changeReceivingPlayerTimerEvent !== null) {
            this.changeReceivingPlayerTimerEvent.timer.remove(this.changeReceivingPlayerTimerEvent);
            this.changeReceivingPlayerTimerEvent = null;
        }

        this.game.time.events.add(250, this.passBallToReceivingPlayer, this);
    }

    public passBallToReceivingPlayer(): void {

        let ball = this.passingPlayer.ball;
        this.passingPlayer.ball = null;
        this.passingPlayer.hasReceived = false;

        this.receivingPlayer = this.switchingPlayersArray[this.activePlayerIndex];
        this.receivingPlayer.ball = ball;

        // poner al jugador que recibe la pelota por encima de todos
        let pegsContainer: any = this.passingPlayer.parent;
        pegsContainer.swap(pegsContainer.getTop(), this.receivingPlayer);

        // quitar la pelota del centrocampista
        ball.parent.removeChild(ball);

        // ponerle las coordenadas correctas respecto al jugador que recibe la pelota
        let startPass_px: number;
        let passingPlayerBall_px: number;

        if (this.passingPlayer.rightPlayer) {
            passingPlayerBall_px = ball.x;
        } else {
            passingPlayerBall_px = - ball.x;
        }

        if (this.receivingPlayer.rightPlayer) {
            startPass_px = -this.receivingPlayer.x + this.passingPlayer.x + passingPlayerBall_px;
        } else {
            startPass_px = this.receivingPlayer.x - this.passingPlayer.x - passingPlayerBall_px;
        }

        const startPass_py = -this.receivingPlayer.y + this.passingPlayer.y + ball.y;

        ball.x = startPass_px;
        ball.y = startPass_py;

        this.passingPlayer = null;

        this.receivingPlayer.addChild(ball);
        this.receivingPlayer.ball = ball;

        const endPass_px = this.receivingPlayer.shootBall_px;
        const endPass_py = this.receivingPlayer.shootBall_py;

        // TODO que el tiempo del pase sea funcion de la distancia entre los jugadores para
        // que la pelota tenga siempre la misma velcocidad
        const t = 1200;
        this.game.add.tween(ball)
            .to({ x: endPass_px, y: endPass_py }, t, Phaser.Easing.Quintic.InOut, true)
            .onComplete.add(this.ballReachedReceivingPlayer, this);

        this.game.add.tween(ball.scale)
            .to({ x: 1.75, y: 1.75 }, t / 2, Phaser.Easing.Quintic.In)
            .to({ x: 1, y: 1 }, t / 2, Phaser.Easing.Quintic.Out)
            .start();
    }

    public ballReachedReceivingPlayer(): void {

        this.receivingPlayer.prepareToShoot();

        // informar al matchmodel de que se puede chutar
        MatchManager.onPlayerReadyToShoot();
    }

    public shootBall(): void {

        const ball = this.receivingPlayer.ball;
        ball.destroy();
        this.receivingPlayer.ball = null;

        this.receivingPlayer.shootBall();
        this.receivingPlayer.hasReceived = false;
    }

    public onGamePaused(): void {

        for (let i = 0; i < this.playersArray.length; i++) {
            const player = this.playersArray[i];
            player.onGamePaused();
        }

        if (this.changeReceivingPlayerTimerEvent) {
            this.changeReceivingPlayerTimerEvent.timer.pause();
        }
    }

    public onGameResumed(): void {

        for (let i = 0; i < this.playersArray.length; i++) {
            const player = this.playersArray[i];
            player.onGameResumed();
        }

        if (this.changeReceivingPlayerTimerEvent) {
            this.changeReceivingPlayerTimerEvent.timer.resume();
        }
    }
}
